import { FilterSection } from '../../features/filter/types'
import { deepClone } from '../deep-clone'

export const cloneDeclarationSection = (key: string, declaration: any): FilterSection | undefined => {
  const sectionToClone = declaration?.sections?.find((section: any) => section?.key === key)
  if (sectionToClone) {
    return deepClone(sectionToClone)
  }
  return undefined
}
